export default "__VITE_ASSET__CLPnnTOp__"